import { mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { blogCategoryContentWidgetStyles as styles } from "@solveindustrial/Widgets/VerndaleBox/BlogCategory/BlogCategoryContentWidget";
import { css } from "styled-components";

styles.wrapper = {
    ...styles.wrapper,
    css: css`
        p,
        li,
        span,
        a,
        em,
        strong,
        blockquote {
            font-size: 18px;
            line-height: 32px;

            ${mediaQueriesBP.maxMD} {
                font-size: 16px;
                line-height: 29px;
            }
        }
    `,
};
